import * as React from 'react';
import Box from '@mui/material/Box';
import {StyledTab, StyledTabs} from './admin';
import {TabPanel} from '../../components/other/tabPanel';
import makeStyles from '@mui/styles/makeStyles';
import AgyleTextField from '../../components/ui/fields/agyleTextField';
import {useCallback, useEffect, useState} from 'react';
import SearchIcon from '@mui/icons-material/Search';
import {useDispatch} from 'react-redux';
import {hasPermission, Permissions} from '../../store/reducers/user';
import {setSnackbar} from '../../store/reducers/globals';
import TrustedDevices from './pinManagement/trustedDevices';
import PinAudit from './pinManagement/pinAudit';
import PinAdministrator from './pinManagement/pinAdministrator';
import UsersPin from './pinManagement/usersPin';
import API from '../../app/api';
import {setLoading} from '../../store/reducers/patient';

const useStyles = makeStyles((theme) => ({
    indicator: {
        backgroundColor: "#448FFF"
    },
    switch_base: {
        "&.Mui-checked": {
            color: "#448FFF"
        },
        "&.Mui-checked + .MuiSwitch-track": {
            backgroundColor: "#448FFF",
        }
    },
}));

export const FilterTextfield = props => {

    const handleChangeValue = (e) => {
        props.onChange(e.target.value);
        props.findValues(e.target.value);
    }

    return (
        <Box sx={{display: "flex", alignItems: "center", gap: 1, m: 2, mt: 4 }}>
            <SearchIcon sx={{color: "#BDBDBD"}}/>
            <AgyleTextField
                placeholder="Filter records"
                variant="outlined"
                size="small"
                value={props.value}
                withBorder
                disabled={props.disabled}
                onChange={handleChangeValue}
                InputProps={{
                    sx: {
                        borderRadius: 10,
                        backgroundColor: "#F5F5F5",
                        width: 300,
                    }
                }}
            />
        </Box>
    )
}

export const filterStringArray = (string, fieldName, defaultValues, setValuesFunction) => {
    if (!string) setValuesFunction(defaultValues);

    const regex = new RegExp(string, 'i')
    const filtered = defaultValues.filter((str) => regex.test(str[fieldName]));

    setValuesFunction(filtered)
}

function PinManagement(props) {
    const dispatch = useDispatch();

    const [value, setValue] = useState(0);
    const classes = useStyles();

    const renderErrorSnackbar = useCallback((message) => {
        dispatch(setSnackbar({
            open: true,
            type: 'error',
            message,
        }))
    }, [])

    const renderSuccessSnackbar = useCallback(
        (message) => {
            dispatch(setSnackbar({
                open: true,
                type: 'success',
                message,
            }));
        }, []);

    const handleChange = (event, newValue) => {
        if (adminCanOnlyManagePins()) {
            return renderErrorSnackbar("You only have permission to manage pins.");
        }
        setValue(newValue);
    };

    const adminCanOnlyManagePins = () => {
        return (
            dispatch(hasPermission(Permissions.CAN_MANAGE_PINS) )
            && !dispatch(hasPermission(Permissions.CAN_ACCESS_PIN_ADMIN)))
    }

    useEffect(() => {
        if (adminCanOnlyManagePins()) {
            setValue(1);
        }
    }, [])

    const setUserPin = async (username, pin) => {
        dispatch(setLoading(true));
        try {
            API.setPinUser(username, pin).then((res) => {
                if (!res.errorCode) {
                    renderSuccessSnackbar("User PIN set successfully.")
                } else {
                    renderErrorSnackbar(`Error setting user PIN. Please try again later. ${res.errorCode}`);
                }
            })
        } catch (e) {
            renderErrorSnackbar("Error setting user PIN. Please try again later.");
        } finally {
            dispatch(setLoading(false));
        }
    }

    return (<Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider',display: "flex" }}>
            <StyledTabs value={value} onChange={handleChange} aria-label="basic tabs example" TabIndicatorProps={{className: classes.indicator}} >
                <StyledTab value={0} label="Trusted Devices"disabled={adminCanOnlyManagePins()} />
                <StyledTab value={1} label="Users & PINs" />
                <StyledTab value={2} label="Audits" disabled={adminCanOnlyManagePins()} />
                {/*<StyledTab value={3} label="Administrator" disabled={adminCanOnlyManagePins()} />*/}
            </StyledTabs>
        </Box>

        <TabPanel value={value} index={0}>
            <TrustedDevices
                renderSuccessSnackbar={renderSuccessSnackbar}
                renderErrorSnackbar={renderErrorSnackbar}
            />
        </TabPanel>
        <TabPanel value={value} index={1}>
            <UsersPin
                renderSuccessSnackbar={renderSuccessSnackbar}
                renderErrorSnackbar={renderErrorSnackbar}
                onSetUserPin={setUserPin}
            />
        </TabPanel>
        <TabPanel value={value} index={2}>
            <PinAudit
                renderSuccessSnackbar={renderSuccessSnackbar}
                renderErrorSnackbar={renderErrorSnackbar}
            />
        </TabPanel>
        {/*<TabPanel value={value} index={3}>*/}
        {/*    <PinAdministrator />*/}
        {/*</TabPanel>*/}
    </Box>)
}

export default PinManagement;